import React from 'react';
import { Link } from 'react-router-dom';
import CampaignsTable from './CampaignsTable';

// Main Campaigns component
// Renders the campaigns page with a header, top cards for stats, and a table of campaigns
const Campaigns: React.FC = () => {
  // JSON data for top cards
  // const topCardsData = {
  //   totalCampaigns: { value: 4, createdThisMonth: 3 },
  //   activeCampaigns: { value: 2 },
  //   openRate: { value: '14.1%', change: '6%' },
  //   clickRate: { value: '6.2%', change: '0.2%' },
  // };

  // Renders the campaigns page layout
  // Includes a header with a create campaign button, stats cards, and campaigns table
  return (
    <div className='p-2'>
      {/* Header Section */}
      <div className='flex justify-between items-center'>
        <div>
          <h2
            className='text-2xl font-bold text-gray-800'
            style={{ color: '#3F5265', fontSize: '24px' }}
          >
            Campaigns
          </h2>
          <p
            className='text-gray-500'
            style={{ color: '#657584', fontSize: '16px' }}
          >
            Create and manage your email campaigns to reach the right audience
            at the right time.
          </p>
        </div>
        <Link
          to='/campaigns/create'
          className='bg-orange-500 text-white px-4 py-2 rounded font-medium hover:bg-orange-600'
          style={{ fontSize: '14px' }}
        >
          + Create Campaign
        </Link>
      </div>

      {/* Stats Cards */}
      {/* <NewTopCards data={topCardsData} /> */}

      {/* Campaigns Table with backend integration and pagination */}
      <CampaignsTable />
    </div>
  );
};

export default Campaigns;